// This type is a simplified version of https://gitlab.tableausoftware.com/extracts/extractable-resource-service-protobuf/blob/master/src/main/proto/tableau/extractableresource/v1/ExtractableResourceService.proto
// which is used by the extract API in this structure https://gitlab.tableausoftware.com/data-composition/published-connection-persistence-service-protobuf/blob/master/src/main/proto/tableau/publishedconnection/v1/ExtractInfo.proto
// For Alpha 3 of Published Connections, Live and Completed will be the two visible states. 
export enum ExtractStatus {
    Completed = 'COMPLETED',
    Live = 'LIVE'
}
